import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NbTooltipModule } from '@nebular/theme';
import { AuthImagePipe } from '../../../../@theme/pipes/auth-image.pipe';

import { OrgChartNodeComponent } from './chart-node.component';

@NgModule({
  declarations: [
    OrgChartNodeComponent,
    AuthImagePipe
  ],
  imports: [
    CommonModule,
    NbTooltipModule
  ],
  bootstrap: [OrgChartNodeComponent],
  exports: [OrgChartNodeComponent]
})
export class OrgChartNodeModule { }
